import { ChangeDetectionStrategy, Component } from '@angular/core'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { Header } from 'app/models/questions/Header'
import { AbstractControl } from '@angular/forms'

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderComponent implements IQuestionComponent {
  isSmallScreen: boolean
  question: Header
  questionFormControl: AbstractControl
  activeLang: string
}
